const type = 'RESET_CALL_HISTORY';

const resetCallHistory = () => ({
  type,
});

export { type };
export default resetCallHistory;
